"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Modal = _interopRequireDefault(require("./Modal"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _CheckBox = _interopRequireDefault(require("../CheckBox/CheckBox"));

var _questionIcon = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/question-icon"));

var _delete = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/delete"));

var _warning = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/warning"));

var _close = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/close-1"));

var _throbber = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/throbber"));

var _underscore = _interopRequireDefault(require("underscore"));

require("./ConfirmationModal.less");

var _NotificationBanner = _interopRequireDefault(require("../NotificationBanner/NotificationBanner"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var noop = function noop() {};

var ConfirmationModal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ConfirmationModal, _React$Component);

  var _super = _createSuper(ConfirmationModal);

  function ConfirmationModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ConfirmationModal);
    _this = _super.call(this, props);
    _this.handleConfirm = _this.handleConfirm.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCancel = _this.handleCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDontShowAgainChange = _this.handleDontShowAgainChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      open: _this.props.show || _this.props.inline,
      dontShowAgain: _this.props.dontShowAgain
    };

    _this.updatePreset(_this.props);

    return _this;
  }

  (0, _createClass2.default)(ConfirmationModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show !== this.state.open || nextProps.inline !== this.props.inline) {
        this.setState({
          open: nextProps.show || nextProps.inline,
          working: false
        });
      }

      if (nextProps.show && nextProps.show !== this.state.open) {
        this.setState({
          dontShowAgain: false
        });
      }

      this.updatePreset(nextProps);
    }
  }, {
    key: "updatePreset",
    value: function updatePreset() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      // create a new preset object that takes the actual preset and merges it with the props to override anything in the preset
      this.preset = Object.assign({}, ConfirmationModal.presets[props.preset || ConfirmationModal.PRESET_CANCEL], _underscore.default.pick(_underscore.default.pick(props, 'title', 'icon', 'line1', 'line2', 'negativeBtn', 'affirmativeBtn'), _underscore.default.identity));
    }
  }, {
    key: "handleConfirm",
    value: function handleConfirm(e) {
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      this.handleCallbackAndClose(this.props.onConfirm, 'affirmative');
      return false;
    }
  }, {
    key: "handleCancel",
    value: function handleCancel(e) {
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      this.handleCallbackAndClose(this.props.onCancel, 'negative');
      return false;
    }
  }, {
    key: "handleClose",
    value: function handleClose(e) {
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      if (this.state.open) {
        this.setState({
          open: false
        });
      }

      return false;
    }
  }, {
    key: "handleCallbackAndClose",
    value: function handleCallbackAndClose(callback, action) {
      var _this2 = this;

      var opts = {
        dontShowAgain: this.state.dontShowAgain
      };
      var ret = (callback || noop)(opts);
      this.setState({
        working: true,
        error: null,
        action: action
      });

      if (ret && ret.then && typeof ret.then === 'function') {
        // its promise, lets wait until the promise is successful to close this
        ret.then(function () {
          _this2.handleClose();
        }).catch(function (msg) {
          // something failed, lets re-activate and show an error
          _this2.setState({
            working: false,
            error: msg
          });
        });
      } else {
        if (ret === false) {
          // something failed, lets re-activate...we were told not to close
          this.setState({
            working: false,
            error: 'An unknown error occurred while trying to confirm your response'
          });
        } else {
          this.handleClose();
        }
      }
    }
  }, {
    key: "handleDontShowAgainChange",
    value: function handleDontShowAgainChange(value) {
      var checked = !!value;
      this.props.onDontShowAgainChange && this.props.onDontShowAgainChange(checked);
      this.setState({
        dontShowAgain: checked
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inline = _this$props.inline,
          className = _this$props.className,
          allowDontShowAgain = _this$props.allowDontShowAgain,
          dontShowAgainLabel = _this$props.dontShowAgainLabel,
          onDontShowAgainChange = _this$props.onDontShowAgainChange,
          disableConfirmBtn = _this$props.disableConfirmBtn;
      var _this$state = this.state,
          error = _this$state.error,
          open = _this$state.open,
          working = _this$state.working,
          action = _this$state.action,
          dontShowAgain = _this$state.dontShowAgain;
      var _this$preset = this.preset,
          title = _this$preset.title,
          icon = _this$preset.icon,
          line1 = _this$preset.line1,
          line2 = _this$preset.line2,
          negativeBtn = _this$preset.negativeBtn,
          affirmativeBtn = _this$preset.affirmativeBtn;
      var ModalWrapper = inline && open ? _Modal.default.Dialog : _Modal.default;

      var errorBanner = error && /*#__PURE__*/_react.default.createElement(_NotificationBanner.default, {
        icon: /*#__PURE__*/_react.default.createElement(_warning.default, null),
        className: "error"
      }, error);

      var negativeButton = null;

      if (this.props.onCancel) {
        negativeButton = /*#__PURE__*/_react.default.createElement(_Button.default, {
          disabled: working,
          onClick: this.handleCancel,
          className: "secondary hollow negative"
        }, working && action === 'negative' ? /*#__PURE__*/_react.default.createElement(_throbber.default, {
          noPad: true
        }) : negativeBtn);
      }

      var affirmativeButton = null;

      if (this.props.onConfirm) {
        affirmativeButton = /*#__PURE__*/_react.default.createElement(_Button.default, {
          disabled: disableConfirmBtn || working,
          onClick: this.handleConfirm,
          className: "secondary affirmative"
        }, !disableConfirmBtn && working && action === 'affirmative' ? /*#__PURE__*/_react.default.createElement(_throbber.default, {
          noPad: true
        }) : affirmativeBtn);
      }

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(ModalWrapper, {
        className: "primitive-confirmation-modal ".concat(inline ? 'inline' : '', " ").concat(className),
        show: open,
        onExited: this.props.onClose
      }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, null, /*#__PURE__*/_react.default.createElement(_Modal.default.Title, null, title), /*#__PURE__*/_react.default.createElement("a", {
        href: "#",
        className: "ui-close",
        "aria-label": "close popup",
        onClick: this.props.onCancel ? this.handleCancel : this.handleClose
      }, /*#__PURE__*/_react.default.createElement(_close.default, null))), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
        className: "text-center"
      }, icon, line1, line2, errorBanner), /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, null, (allowDontShowAgain || onDontShowAgainChange) && /*#__PURE__*/_react.default.createElement(_CheckBox.default, {
        className: "dont-show-again",
        name: "dont-show-again",
        label: dontShowAgainLabel,
        onChange: this.handleDontShowAgainChange,
        checked: dontShowAgain
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "action-buttons"
      }, negativeButton, affirmativeButton))));
    }
  }], [{
    key: "PRESET_NONE",
    get:
    /**  @return {string} */
    function get() {
      return 'PRESET_NONE';
    }
    /**  @return {string} */

  }, {
    key: "PRESET_CANCEL",
    get: function get() {
      return 'PRESET_CANCEL';
    }
    /**  @return {string} */

  }, {
    key: "PRESET_DELETE",
    get: function get() {
      return 'PRESET_DELETE';
    }
    /**  @return {string} */

  }, {
    key: "PRESET_LEAVE_UNSAVED",
    get: function get() {
      return 'PRESET_LEAVE_UNSAVED';
    }
  }, {
    key: "propTypes",
    get: function get() {
      return {
        /** Whether the modal should be shown or not */
        show: _propTypes.default.bool,

        /** Whether the modal should be shown inline or as an actual modal overlay */
        inline: _propTypes.default.bool,

        /** Preset to use to provide default properties (icon, line1, line2, etc). All of these can be overridden through other props */
        preset: _propTypes.default.oneOf([ConfirmationModal.PRESET_NONE, ConfirmationModal.PRESET_CANCEL, ConfirmationModal.PRESET_DELETE, ConfirmationModal.PRESET_LEAVE_UNSAVED]),

        /** Method invoked when the affirmative/confirm button is pressed. The parameter contains states for options in the modal, such as `dontShowAgain` */
        onConfirm: _propTypes.default.func,

        /** Method invoked when the negative/cancel button is pressed. The parameter contains states for options in the modal, such as `dontShowAgain` */
        onCancel: _propTypes.default.func,

        /** Method invoked when the close button is pressed */
        onClose: _propTypes.default.func,

        /** Node to render as the modal title */
        title: _propTypes.default.node,

        /** Node to render as the icon */
        icon: _propTypes.default.node,

        /** Node to render as line 1 */
        line1: _propTypes.default.node,

        /** Node to render as line 2 */
        line2: _propTypes.default.node,

        /** Node to render as the affirmative/confirm button */
        affirmativeBtn: _propTypes.default.node,

        /** Node to render as the negative/cancel button */
        negativeBtn: _propTypes.default.node,

        /** Whether or not the modal should be shown again. If set to false and we attempt to show the modal, we will invoke onConfirm */
        dontShowAgain: _propTypes.default.bool,

        /** Enables the dont show this again checkbox. */
        allowDontShowAgain: _propTypes.default.bool,

        /** Method invoked anytime the 'dont show this again' checkbox is toggled. Overrides allowDontShowAgain to be true */
        onDontShowAgainChange: _propTypes.default.func,

        /** Node to render as the don't show this again checkbox label */
        dontShowAgainLabel: _propTypes.default.node,

        /** Whether to disable affirmative/confirm button */
        disableConfirmBtn: _propTypes.default.bool
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        className: '',
        preset: ConfirmationModal.PRESET_NONE,
        inline: false,
        show: false,
        onConfirm: null,
        onCancel: null,
        onClose: _underscore.default.noop,
        dontShowAgain: false,
        dontShowAgainLabel: 'Don\'t show this message again',
        disableConfirmBtn: false
      };
    }
  }, {
    key: "presets",
    get: function get() {
      return {
        PRESET_NONE: {
          title: 'Are you sure you want to do this?',
          icon: /*#__PURE__*/_react.default.createElement("div", {
            className: "confirmation-icon"
          }, /*#__PURE__*/_react.default.createElement(_questionIcon.default, null)),
          line1: /*#__PURE__*/_react.default.createElement("h4", null, "Are you sure you want to do this?"),
          line2: null,
          negativeBtn: 'No, let\'s go back',
          affirmativeBtn: 'Yes, continue'
        },
        PRESET_CANCEL: {
          title: 'Are you sure you want to cancel?',
          icon: /*#__PURE__*/_react.default.createElement("div", {
            className: "confirmation-icon"
          }, /*#__PURE__*/_react.default.createElement(_questionIcon.default, null)),
          line1: /*#__PURE__*/_react.default.createElement("h4", null, "Are you sure you want to cancel this process?"),
          line2: /*#__PURE__*/_react.default.createElement("p", null, "Your progress will be lost"),
          negativeBtn: 'No, let\'s go back',
          affirmativeBtn: 'Yes, continue with cancel'
        },
        PRESET_DELETE: {
          title: 'Are you sure you want to delete your work?',
          icon: /*#__PURE__*/_react.default.createElement("div", {
            className: "confirmation-icon"
          }, /*#__PURE__*/_react.default.createElement(_delete.default, null)),
          line1: /*#__PURE__*/_react.default.createElement("h4", null, "Are you sure you want to delete this work in progress?"),
          line2: /*#__PURE__*/_react.default.createElement("p", null, "This work will be permanently deleted."),
          negativeBtn: 'No, let\'s go back',
          affirmativeBtn: 'Yes, delete now'
        },
        PRESET_LEAVE_UNSAVED: {
          title: 'Are you sure you want to leave without saving?',
          icon: /*#__PURE__*/_react.default.createElement("div", {
            className: "confirmation-icon"
          }, /*#__PURE__*/_react.default.createElement(_questionIcon.default, null)),
          line1: /*#__PURE__*/_react.default.createElement("h4", null, "You have unsaved changes!"),
          line2: /*#__PURE__*/_react.default.createElement("p", null, "Your changes will not take effect if you leave this screen without saving."),
          negativeBtn: 'No, let\'s stay here',
          affirmativeBtn: 'Yes, leave without saving'
        }
      };
    }
  }]);
  return ConfirmationModal;
}(_react.default.Component);

exports.default = ConfirmationModal;